import React from 'react';

import logo from "../../assets/img/logo.png";
import {Helmet} from "react-helmet";
import {FormattedMessage} from "react-intl";
import Map from "./Map";


const meta = require("../../translations/meta.json");


export default class About extends React.Component {

    render() {

        return <div className={"freight_forwarding"} dir={this.props.lang === "ar" ? "rtl" : "ltr"}>
            {!this.props.no_meta && <Helmet>
                <title>{meta[this.props.lang].about.title}</title>
                <meta name="description"
                      content={meta[this.props.lang].about.description}
                />
            </Helmet>}

            <div className={"r "}>
                <div className={"c-1-1"}>

                    <div className={"r prolog_logo"}>
                        <div className={"c-1-1"}>
                            <img src={logo} alt={"prolog logo"}/>
                        </div>
                    </div>
                    <div className={"r ff-description"}>
                        <div className={"c-1-1"}>
                            <p><FormattedMessage id={"about.p1"}/></p>
                            <p><FormattedMessage id={"about.p2"}/></p>
                            <p><FormattedMessage id={"about.p3"}/></p>
                            <p><FormattedMessage id={"about.p4"}/></p>
                            <p><FormattedMessage id={"about.p5"}/></p>
                        </div>
                    </div>
                </div>

            </div>
            <Map lang={this.props.lang}/>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/pages/About.js